import { render } from "./pricing-detail.vue?vue&type=template&id=58b4e859"
import script from "./pricing-detail.vue?vue&type=script&lang=js"
export * from "./pricing-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__